<template>
    <div class="cases-listing-table">
        <b-row>
            <b-col cols="12">
                <button type="button" class="btn-icon-clipboard">
                    <router-link to="/casesCalendar">
                        <div>
                            <i class="ni ni-calendar-grid-58"></i>
                            <span>Calendar View</span>
                        </div>
                    </router-link>
                </button>
            </b-col>
        </b-row>
        <b-row class="mb-4 mx-3 filter-buttons">
            <b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :pressed="selectedButton === 'All'"
                    class="mb-2 mr-2 shadow-none bg-dark"
                    @click="filterByStatus('')"
                >
                    <p class="text-white">All</p>
                    <span class="font-weight-600 text-white"> {{ _gHlp.getValue(summary,'sts_all',0) }}</span>
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :pressed="selectedButton === 'no_status'"
                    class="mb-2 mr-2 shadow-none"
                    variant="outline-primary"
                    @click="filterByStatus('no_status')"
                >
                    <p>No Status</p>
                    <span class="font-weight-600"> {{ _gHlp.getValue(summary,'no_status',0) }}</span>
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1" v-for="(item,index) in list_main_mortgage_status" :key="index">
                <b-button 
                    block
                    :pressed="selectedButton === item.status"
                    variant="outline-primary"
                    class="mb-2 mr-2 shadow-none"
                    @click="filterByStatus(item.status)"
                >
                    <p>{{ item.status }}</p>
										<span class="font-weight-600"> {{ _gHlp.getValue(summary,item.status,0) }}</span>
                </b-button>
            </b-col>
        </b-row>
        
        
        <b-row class="d-flex justify-content-md-between">
            <b-col cols="12">
                <b-row class="d-flex justify-content-end">
                    <b-col cols="12" md="auto" class="float-right text-right">
                        <p>Total SPA Price</p>
                        <h3 class="text-primary font-weight-600">RM {{ _gHlp.getValue(summary,'total.spa_price',0) | moneyFormatter }}</h3>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <MortgageTable :tableData="tableData" :tablePagination="tablePagination" :tableSummary="summary" :tableFilters="tableFilters" ref="mortgageTableRef" @onFilter="onFilter($event)"/>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import MortgageTable from '@/views/Cases/CasesTables/Mortgage/MortgageTable.vue'
import { mapState } from 'pinia'
import { useLookupStore } from '@/stores/lookupStore'

export default {
    props:['tableData','tablePagination','tableSummary','tableFilters'],
    components: {
        MortgageTable,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
					summary:{},
					filters:{
						search : {
							prod_main_status:'all'
						}
					},
					selectedButton: 'All',
					selectedSubButton: 'All',
        }
    },
    computed:{
				...mapState(useLookupStore, ['list_main_mortgage_status','list_sub_mortgage_status']),
    },
    watch:{
				tableFilters:{
            handler(newVal){
						this.filters = {...this.filters, ...newVal};
            },
            immediate: true
       },    
			 tableSummary:{
					handler(newVal){
						this.summary = newVal;
					},
					immediate: true
       }
    },
    methods: {
				filterByStatus(sts) {
					this.selectedButton = !_gHlp.isEmpty(sts) ? sts : 'All';
					this.filters.search.prod_main_status = sts
					this.filters.is_reset_summary = false
					this.filters.page = 1
					this.$emit('onFilter',this.filters);
        },
				onFilter(event) {
					this.filters = {...this.filters,...event}
          this.$emit('onFilter',this.filters);
				}
    },
}
</script>